/** Shows the error message, unless its code is special-cased below with richer text. */

import {Link} from '@primer/react'
import type {ReactNode} from 'react'

import type {BoardMoveRefusalDetails} from './board-move-errors'

export type RefusedMove = {
  message: string
  field?: string
  code?: string
  details: BoardMoveRefusalDetails
  /** The board's label for the value the card was dropped on. */
  targetLabel?: string
}

/** Return undefined to fall back to `message`. */
type RefusedMoveExplanation = (refusal: RefusedMove) => ReactNode | undefined

const REFUSED_MOVE_EXPLANATIONS: Readonly<Record<string, RefusedMoveExplanation>> = {
  missing_in_repository: ({field, details, targetLabel}) => {
    const {repository, repositoryUrl} = details
    if (field !== 'milestone' || !targetLabel || typeof repository !== 'string' || typeof repositoryUrl !== 'string') {
      return undefined
    }
    return (
      <>
        Please create the <code>{targetLabel}</code> milestone in the{' '}
        <Link inline href={`${repositoryUrl}/milestones`}>
          {repository}
        </Link>{' '}
        repository to add this item to this milestone group.
      </>
    )
  },
}

export function RefusedMoveMessage({refusal}: {refusal: RefusedMove}) {
  const {code} = refusal
  const explain =
    code !== undefined && Object.hasOwn(REFUSED_MOVE_EXPLANATIONS, code) ? REFUSED_MOVE_EXPLANATIONS[code] : undefined
  return explain?.(refusal) ?? refusal.message
}
